(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .constant('scoreDetailResolver', {
            data: getData
        });

    getData.$inject = ['$transition$', 'Score'];
    function getData($transition$, Score) {
        var params = $transition$.params(),
            scoreId = params.scoreId;

        return Score.getScoreDetails({ scoreId: scoreId }).$promise;
        // return Score.getScoreDetails({ scoreId: scoreId }).$promise.then(modifyForTesting);
    }

    function modifyForTesting(x) {
        x.isHoleByHole = true;
        x.isTrackingStats = true;
        x.holesPlayed = 'EighteenHoles';

        // Main
        x.name = null;
        x.course = null;
        x.playDate = null;

        x.tee = null;
        x.rating = null;
        x.slope = null;
        x.par = null;
        x.esc = null;
        x.differential = null;
        x.postedDate = null;

        // Score
        x.gross = 66;
        x.toPar = 5;
        x.albatross = 2;
        x.eagles = 2;
        x.birdies = 2;
        x.pars = null;
        x.bogeys = null;
        x.doubles = null;
        x.others = null;

        // Par Performance
        x.par3 = null;
        x.par4 = null;
        x.par5 = null;

        // GIR
        x.girHit = null;
        x.girOpp = null;
        x.girPercent = null;
        x.putts = null;
        x.puttsPerHole = null;
        x.proximity = null;

        // Fir
        x.firHit = null;
        x.firOpp = null;
        x.firPercent = null;
        x.firLong = null;
        x.firRight = null;
        x.firShort = null;
        x.firLeft = null;
        x.firOther = null;

        // Recovery
        x.upDownHit = null;
        x.upDownOpp = null;
        x.upDownPercent = null;

        x.sandSaveHit = null;
        x.sandSaveOpp = null;
        x.sandSavePercent = null;

        x.scrambleHit = null;
        x.scrambleOpp = null;
        x.scramblePercent = null;

        x.bounceBackHit = null;
        x.bounceBackOpp = null;
        x.bounceBackPercent = null;

        return x;
    }
})();